var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.1,
    height: 42,
    viewBox: "0 0 42.1 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_100",
    x: 11.9,
    y: 0.1,
    width: 30.2,
    height: 30.2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_101",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_100)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_100-2",
    "data-name": "Pfad 100",
    className: "cls-1",
    d: "M21.4,21.9v2.4h5.1V21.9a9.995,9.995,0,0,0,7.1-7.1h2.5V9.6H33.6a9.995,9.995,0,0,0-7.1-7.1V.1H21.4V2.5a9.829,9.829,0,0,0-7.1,7.1H11.9v5.1h2.4A10.3,10.3,0,0,0,21.4,21.9Zm4.1-.8v2.2H22.4V20.2h3.1Zm8.4-10.5h1.2v3.1H32V10.6h1.9ZM22.4,3.3V1.1h3.1V4.2H22.4Zm-1,.3V5.2h5.1V3.6a9.3,9.3,0,0,1,6.1,6.1H31v5.1h1.6a9.3,9.3,0,0,1-6.1,6.1V19.3H21.4v1.6a9.3,9.3,0,0,1-6.1-6.1H17V9.6H15.4A8.638,8.638,0,0,1,21.4,3.6ZM12.9,13.7V10.6H16v3.1H12.9Z",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_101)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_101-2",
    "data-name": "Pfad 101",
    fill: "#f5f5f5",
    d: "M34,18h0A16,16,0,1,1,18,2V0A18,18,0,1,0,36,18H34Z",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.16ddf5757cbaaeb07a469ed1fec0f68d.svg";
export { ForwardRef as ReactComponent };